import { ResponseError } from 'services/api/base';
import { useGetAaoNaoOptionsQuery } from 'services/api/Meteorology/Weather/Area/Status/AAONAO';
import useHandleRequestErrors from 'utils/hooks/useHandleRequestErrors';

export default function useAaoNaoOptions(area: 'aao' | 'nao') {
  const {
    data, error, isLoading,
  } = useGetAaoNaoOptionsQuery({ area });

  useHandleRequestErrors(error as ResponseError);

  return { data, isLoading };
}
